import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Spacing, Colors, Palette, Dimensions } from '@/shared/theme';
import { Text } from '@/shared/ui';

import monitorWithPhoneImage from '@/assets/images/Landing/monitor-with-phone.png';
import openAppImage from '@/assets/images/Landing/open-app.png';
import checkReportImage from '@/assets/images/Landing/check-report.png';
import iconCheckCircle from '@/assets/images/Landing/icon-check-circle.svg';

const Container = styled.div`
  display: flex;
  gap: ${Spacing.x2}px;

  @media (max-width: ${Dimensions.gridWidth - 1}px) {
    flex-direction: column;
  }
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${Spacing.x3}px;
  background-color: ${Palette.darkNearWhite};
  border-radius: 12px;
  padding: ${Spacing.x2}px;
`;

const CardImageContainer = styled.div`
  width: 100%;
  height: 135px;
  background-color: ${Colors.background};
  border-radius: 6px;
  overflow: hidden;

  @media (max-width: ${Dimensions.gridWidth - 1}px) {
    height: 192px;
    border-radius: 8px;
  }
`;

const CardImageFill = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ChecklistContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.x2}px;
`;

const ChecklistItem = styled.div`
  display: flex;
  gap: ${Spacing.x1_5}px;
`;

const CheckIcon = styled.img`
  width: 24px;
  height: 24px;
  margin-top: ${Spacing.x0_5}px;
`;
const CardsRow = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <Card>
        <CardImageContainer>
          <CardImageFill
            src={monitorWithPhoneImage}
            alt="Welcome kit with blood pressure monitor"
          />
        </CardImageContainer>
        <ChecklistContainer>
          <ChecklistItem>
            <CheckIcon src={iconCheckCircle} alt="" aria-hidden="true" />
            <Text size="p1">{t('landing.wyg-card1-item1')}</Text>
          </ChecklistItem>
          <ChecklistItem>
            <CheckIcon src={iconCheckCircle} alt="" aria-hidden="true" />
            <Text size="p1">{t('landing.wyg-card1-item2')}</Text>
          </ChecklistItem>
        </ChecklistContainer>
      </Card>

      <Card>
        <CardImageContainer>
          <CardImageFill src={openAppImage} alt="Heart health tracking app" />
        </CardImageContainer>
        <ChecklistContainer>
          <ChecklistItem>
            <CheckIcon src={iconCheckCircle} alt="" aria-hidden="true" />
            <Text size="p1">{t('landing.wyg-card2-item1')}</Text>
          </ChecklistItem>
          <ChecklistItem>
            <CheckIcon src={iconCheckCircle} alt="" aria-hidden="true" />
            <Text size="p1">{t('landing.wyg-card2-item2')}</Text>
          </ChecklistItem>
        </ChecklistContainer>
      </Card>

      <Card>
        <CardImageContainer>
          <CardImageFill src={checkReportImage} alt="Secure reports for your doctor" />
        </CardImageContainer>
        <ChecklistContainer>
          <ChecklistItem>
            <CheckIcon src={iconCheckCircle} alt="" aria-hidden="true" />
            <Text size="p1">{t('landing.wyg-card3-item1')}</Text>
          </ChecklistItem>
          <ChecklistItem>
            <CheckIcon src={iconCheckCircle} alt="" aria-hidden="true" />
            <Text size="p1">{t('landing.wyg-card3-item2')}</Text>
          </ChecklistItem>
        </ChecklistContainer>
      </Card>
    </Container>
  );
};

export default CardsRow;
